var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83789 16.7642C-3.31076 10.4807 1.20554 0 9.93436 0H69.0635C77.7964 0 82.3086 10.4807 76.164 16.7642L42.5368 51.1596V72.9231H56.6892C57.4949 72.9231 58.2676 73.2432 58.8373 73.813C59.4071 74.3828 59.7271 75.1557 59.7271 75.9615C59.7271 76.7674 59.4071 77.5402 58.8373 78.1101C58.2676 78.6799 57.4949 79 56.6892 79H22.3127C21.507 79 20.7343 78.6799 20.1646 78.1101C19.5949 77.5402 19.2748 76.7674 19.2748 75.9615C19.2748 75.1557 19.5949 74.3828 20.1646 73.813C20.7343 73.2432 21.507 72.9231 22.3127 72.9231H36.4651V51.1555L2.83789 16.7642ZM39.503 45.5688L51.3831 33.4231H27.6229L39.503 45.5688ZM21.6808 27.3462H57.3252L71.826 12.5185C74.155 10.1323 72.4943 6.07692 69.0716 6.07692H9.93436C6.51169 6.07692 4.85099 10.1323 7.18002 12.5185L21.6808 27.3462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2);
export default __webpack_public_path__ + "static/media/v2.a175194cad08ff1ebf2799628b751504.svg";
export { ForwardRef as ReactComponent };